<template>
  <div class="bg-highlight-primary-background text-highlight-primary-background mb-6 px-6 pt-5 pb-6">
    <slot />
  </div>
</template>
